import { v1 as uuidv1 } from 'uuid';
import ThumbnailCard from '../common/ThumbnailCard';
import { getPageStyle } from '../common/LessonPageUtil';
import './SortingCardThumbnail.scss';

import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  promptCardsConfig: [],
  responseCardsConfig: [],
  isSmallThumbnail: false,
};

export default function SortingCardThumbnail(p) {
  const { promptCardsConfig, responseCardsConfig, isSmallThumbnail } = { ...defaultProps, ...filterUndefined(p) };
  const createCard = (className, cards) => (
    cards.map((c) => {
      const caredId = uuidv1();
      return (
        <ThumbnailCard
          id={caredId}
          key={caredId}
          image={c.image}
          text={c.text}
          isSmallThumbnail={isSmallThumbnail}
          className={className}
          style={getPageStyle(c, true)}
        />
      );
    })
  );

  return (
    <div className='sorting-card-thumbnail'>
      <div className='sorting-card-prompts'>
        {createCard('sorting-card-prompt', promptCardsConfig)}
      </div>
      <div className='sorting-card-responses'>
        {createCard('sorting-card-response', responseCardsConfig)}
      </div>
    </div>
  );
}
